import * as React from "react";
import { TextField } from "@mui/material";
import dayjs from "dayjs";
import ConfirmModal from "../confirm.modal";
import type { ModalComponentProps } from "../../../types/modal.types";

interface BranchSuspendModalProps extends ModalComponentProps {
  /** 오늘부터 day 일 정지 확정 */
  onConfirm: (day: number) => void;
}

const MAX_DAY = 365;

/** 오늘부터 day 일 정지 → 종료일 (오늘 포함) */
const banEndDate = (day: number) =>
  dayjs().add(Math.max(day - 1, 0), "day").format("YYYY-MM-DD");

export default function BranchSuspendModal({ id, onClose, onConfirm }: BranchSuspendModalProps) {
  const [dayText, setDayText] = React.useState("");

  const day = Number(dayText);
  const isValid = dayText !== "" && Number.isInteger(day) && day > 0 && day <= MAX_DAY;

  return (
    <ConfirmModal
      id={id}
      onClose={onClose}
      className="w-[600px]"
      title="지점 정지"
      rightButton={{
        title: "지점 정지처리",
        variant: isValid ? "danger" : "disabled",
        disabled: !isValid,
        onClick: () => {
          onConfirm(day);
          onClose?.();
        },
      }}
    >
      <div className="mt-6 flex-row items-center gap-4">
        <span className="text-style-body-03 whitespace-nowrap">오늘부터</span>
        <TextField
          className="flex-1"
          value={dayText}
          placeholder="일자 숫자만 입력"
          inputMode="numeric"
          inputProps={{ maxLength: 3, style: { textAlign: "right" } }}
          onChange={(e) => setDayText(e.target.value.replace(/[^0-9]/g, ""))}
          slotProps={{ input: { sx: { height: "44px" } } }}
        />
        <span className="text-style-body-03 whitespace-nowrap">일 정지 처리</span>
      </div>
      <p className="text-style-compact-04 text-primary-50 mt-2 h-5 text-right font-normal">
        {isValid ? `~ ${banEndDate(day)}까지 정지` : ""}
      </p>
    </ConfirmModal>
  );
}
